import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { CategoriiDocumenteService } from '../categorii-documente.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { CategorieDocumente } from '../categorii-documente.interface';
import { finalize } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-add-categorii-documente',
    templateUrl: './add-categorii-documente.component.html',
    styleUrls: ['./add-categorii-documente.component.scss']
})
export class AddCategoriiDocumenteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;
    categoriiDocumente: Generic[] = [];

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        id_parent: new FormControl(''),
        slug: new FormControl('', [Validators.required]),
        content: new FormControl('', [Validators.required]),
        observations: new FormControl(''),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<AddCategoriiDocumenteComponent>,
        private categoriiDocumenteService: CategoriiDocumenteService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
        this.categoriiDocumente = data.categoriiDocumente;
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.categoriiDocumenteService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_parent, slug, content, observations } = this.form
            .value as CategorieDocumente;
        const newCategorie: CategorieDocumente = {
            name,
            id_parent,
            slug,
            content,
            observations,
        };

        this.categoriiDocumenteService
            .addCategorie(newCategorie)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
